import React from "react";
import pdfFile from "../pdfs/Tipkit-RoomAttendantGuide-english.pdf";
import PdfViewer from "../comman/PdfViewer";
import { onboardingDocs } from "../consfig";

const AttendantGuidInEnglish = () => {
  const pdfUrl = onboardingDocs.b2c.attendants;
  return <PdfViewer pdfFile={pdfUrl} />;
};

export default AttendantGuidInEnglish;
